import axios from 'axios'
import { Discount } from '../../interfaces'

export const createDiscount = async (discount: Discount) => {
  const response = await axios.post('/data/atlaide', discount)

  return response.data
}
